import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch,
  SwitchProps,
  Text,
  useDisclosure,
} from '@elkaso-app/web-design';
import { useUpdateCategoryApi } from 'apis/categories/use-update-category-api';

export interface ICategoryActivationSwitchCell extends SwitchProps {
  categoryId: number;
  isActive: boolean;
}

export const CategoryActivationSwitch = ({ categoryId, isActive, ...rest }: ICategoryActivationSwitchCell) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { mutate: updateCategoryV2, isLoading: isUpdateCategoryV2Loading } = useUpdateCategoryApi();

  const handleActivateCategory = () => {
    const variables = {
      categoryId,
      body: {
        isActive: !isActive,
      },
    };

    updateCategoryV2(variables, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <>
      <FormControl display='flex' alignItems='center'>
        <Switch id={`active-category-${categoryId}`} onChange={onOpen} isChecked={isActive} {...rest} />
        <FormLabel
          htmlFor={`active-category-${categoryId}`}
          mb='0'
          ms='sm'
          userSelect='none'
          fontWeight='normal'
          fontSize='sm'>
          {isActive ? 'Active' : 'Inactive'}
        </FormLabel>
      </FormControl>

      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{isActive ? 'Deactivate' : 'Activate'} category!</ModalHeader>

          <ModalBody>
            {isActive && <Text>Are you sure you want to deactivate this category?</Text>}
            {!isActive && <Text>Are you sure you want to activate this category?</Text>}
          </ModalBody>

          <ModalFooter>
            <HStack spacing='md'>
              <Button variant='outline' colorScheme='red' onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant='solid'
                colorScheme='red'
                onClick={handleActivateCategory}
                isLoading={isUpdateCategoryV2Loading}>
                {isActive ? 'Deactivate' : 'Activate'}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
